const ROUTES = {
  LoginPage: '/login',
  DashboardPage: '/dashboard',
  ShowcasePage: '/showcase',
  Pricing: '/pricing',
}

export default ROUTES
